import { FC } from "react";
import { Path, Svg } from "react-native-svg";

import { tSvgProps } from "../types";

const PdArrowUpRight: FC<tSvgProps> = (props) => (
  <Svg viewBox="0 0 10 10" fill="none" {...props}>
    <Path
      d="M3.61 0a.369.369 0 0 0 0 .737h5.132L.108 9.37a.369.369 0 0 0 .521.521l8.634-8.634v5.131a.368.368 0 1 0 .737 0V0H3.61Z"
      fill="currentColor"
    />
  </Svg>
);

export default PdArrowUpRight;
